import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaTelegramPlane, FaViber, FaVk, FaFacebookMessenger } from 'react-icons/fa';

import { Avatar } from '@mssgme/ui';
import styles from './ConversationItem.scss';

export const PLATFORMS = ['whatsapp', 'telegram', 'viber', 'messenger', 'vk'];

export const PLATFORM_ICONS_MAP = {
    whatsapp: IoLogoWhatsapp,
    telegram: FaTelegramPlane,
    viber: FaViber,
    messenger: FaVk,
    vk: FaFacebookMessenger,
};

ConversationItem.propTypes = {
    id: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    username: PropTypes.string.isRequired,
    lastMessage: PropTypes.string.isRequired,
    lastActivity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isNew: PropTypes.bool,
    isBlocked: PropTypes.bool,
    isMessageUpcoming: PropTypes.bool,
    platform: PropTypes.oneOf(PLATFORMS).isRequired,
};

ConversationItem.defaultProps = {
    isNew: false,
    isBlocked: false,
    isMessageUpcoming: false,
};

export default function ConversationItem({
    id,
    avatar,
    username,
    lastMessage,
    lastActivity,
    isMessageUpcoming,
    isNew,
    isBlocked,
    platform,
    ...rest
}) {
    const { t } = useTranslation('inbox');
    const PlatformIcon = PLATFORM_ICONS_MAP[platform];
    const { url } = useRouteMatch();

    return (
        <NavLink to={`${url}/${id}`} className={styles.root} activeClassName={styles.active} {...rest}>
            <div className={styles.body}>
                <Avatar className={styles.avatar} src={avatar} name={username} size={40} />
                <div className={styles.bodyRight}>
                    <div className={styles.head}>
                        <div className={styles.username}>{username}</div>
                        <div className={styles.time}>{moment(lastActivity).fromNow()}</div>
                    </div>
                    <div className={styles.content}>
                        <p className={classNames(styles.message, { [styles.blockedClient]: isBlocked })}>
                            {isBlocked ? (
                                t('uiConversation.blocked')
                            ) : (
                                <>
                                    {isMessageUpcoming && t('uiConversation.you')}
                                    {lastMessage}
                                </>
                            )}
                        </p>
                        {isNew && <span className={styles.newDot} />}
                        {!isNew && <PlatformIcon size={14} color="#8E8E8E" className={styles.platformIcon} />}
                    </div>
                </div>
            </div>
        </NavLink>
    );
}
